import type { Language } from '../types/language';

export interface ProcessStep {
  number: string;
  title: Record<Language, string>;
  description: Record<Language, string>;
}

export const processSteps: ProcessStep[] = [
  {
    number: '01',
    title: { en: 'Tell Me About Your Event', es: 'Cuéntame sobre tu proyecto' },
    description: { en: 'Share your date, vision and the moment you want to create.', es: 'Comparte tu fecha, visión y el momento que quieres crear.' },
  },
  {
    number: '02',
    title: { en: 'We Design The Experience', es: 'Diseñamos la experiencia' },
    description: { en: 'The concept, music and choreography are shaped around you.', es: 'El concepto, la música y la coreografía se diseñan alrededor de ti.' },
  },
  {
    number: '03',
    title: { en: 'We Rehearse And Prepare', es: 'Ensayamos y nos preparamos' },
    description: { en: 'Learn comfortably, step by step, with personal guidance.', es: 'Aprende cómodamente, paso a paso, con guía personalizada.' },
  },
  {
    number: '04',
    title: { en: 'You Enjoy The Moment', es: 'Disfrutas el momento' },
    description: { en: 'Arrive prepared, feel confident and be fully present.', es: 'Llega preparado, siente confianza y disfruta plenamente.' },
  },
];
